/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import PerformanceService, { PerformanceMetric } from 'cio/services/performance';
import { registerDestructor } from '@ember/destroyable';
interface LoadingGearsArgs {
  message: string;
  trackPerformanceMetrics?: boolean;
}

export default class LoadingGears extends Component<LoadingGearsArgs> {
  @service performance!: PerformanceService;

  gearLoadersImage = new URL('cio/assets/images/gear-loaders.svg', import.meta.url).toString();

  constructor(owner: unknown, args: LoadingGearsArgs) {
    super(owner, args);

    // Tracks when the loading gears are added and removed from the DOM.
    // Specifically targeting this visual element because it's an important
    // element of what the user perceives as "loading".
    if (args.trackPerformanceMetrics === true) {
      this.performance.recordMetric(PerformanceMetric.JourneysLoadingGearsDisplay);

      registerDestructor(this, () => {
        this.performance.recordMetric(PerformanceMetric.JourneysLoadingGearsHide);
      });
    }
  }
}
